module.exports = __webpack_public_path__ + "cb2eb9e838ba514ce078ae0d0ea8be3c.png";